import { render } from "./Overlay.vue?vue&type=template&id=43086879&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"

import "./Overlay.vue?vue&type=style&index=0&id=43086879&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43086879"],['__file',"src/vue/components/Overlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43086879"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43086879', __exports__)) {
    api.reload('43086879', __exports__)
  }
  
  module.hot.accept("./Overlay.vue?vue&type=template&id=43086879&scoped=true", () => {
    api.rerender('43086879', render)
  })

}


export default __exports__